import PageTitle from '../../components/Pagetitle/Pagetitle';
import Card from '../../components/Card/Card';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import Modal from '../../components/Modal/Modal';
import Tabs from '../../components/Tabs/Tabs';
import { mapActions, mapGetters } from 'vuex';
import ChoiceGroup from '../../components/ChoiceGroup/ChoiceGroup';
import FileInput from '../../components/FileInput/FileInput';
import ToastWrapper from '@/components/ToastWrapper/ToastWrapper';

import Context from '@/models/Context';
import Topic from '@/models/strategy/Topic';
import Avatar from '@/components/Avatar/Avatar';
import Uploader from '@/utils/Uploader';
import arraysData from '@/utils/ArraysData';

export default {
  name: 'Settings',
  components: {
    FileInput,
    PageTitle,
    Card,
    Button,
    Input,
    Modal,
    Tabs,
    ChoiceGroup,
    Avatar,
    ToastWrapper
  },
  props: [],
  data() {
    return {
      showModal: false,
      tabData: [
        { name: 'Own picture', slug: 'own_picture', active: true },
        { name: 'Avatars', slug: 'avatars' }
      ],
      sectionsTabData: [
        { name: 'Personal', slug: 'personal', active: true },
        { name: 'Themes', slug: 'themes', active: false }
        // { name: 'Company', slug: 'company' },
        // { name: 'Billing', slug: 'billing' },
        // { name: 'Integrations', slug: 'integrations' }
      ],
      update: {
        password: '',
        confirm: ''
      },
      selectedSectionTab: { name: 'Personal', slug: 'personal' },
      selectedTab: { name: 'Own picture', slug: 'own_picture' },
      defaultAvatars: [],
      selectedAvatar: '',
      hasUpload: false,
      modal: {
        avatar: false,
        destroy: false
      },
      originalThemes: [],
      memberThemes: []
    };
  },
  computed: {
    member: function() {
      if (!this.isLoading) {
        const context = Context.query()
          .where(context => {
            return context.id === 'current';
          })
          .with('user')
          .first();
        if (context.isLoaded) {
          this.originalThemes = context.membership.topics;
          this.memberThemes = context.membership.topics;
          return context;
        }
      }

      return { isLoaded: false };
    },

    teamTopics: function() {
      if (!this.isLoading) {
        return Topic.all();
      } else {
        return null;
      }
    },

    isValid: function() {
      return (
        this.member.user.firstName.trim().length === 0 ||
        this.member.user.lastName.trim().length === 0 ||
        this.isValidPassword
      );
    },

    isValidPassword: function() {
      return (
        (this.update.password.trim().length >= 3 &&
          this.update.password.trim() === this.update.confirm.trim()) ||
        this.update.password === ''
      );
    },

    isLoading: function() {
      return this._isLoading();
    },

    isUpdating: function() {
      return this._isUpdating();
    },

    isDeleting: function() {
      return this._isDeleting();
    }
  },
  mounted() {
    this.selectedTab = this.tabData.find(tab => {
      return tab.active;
    });

    for (let counter = 1; counter <= 20; counter++) {
      this.defaultAvatars.push(`/avatars/Av${counter}.png`);
    }
  },
  beforeMount() {
    this._topics();
  },
  methods: {
    ...mapActions({
      _newToast: 'toasts/_addToast',
      _userUpdate: 'entities/users/update',
      _memberRemove: 'entities/memberships/remove',
      _memberThemes: 'entities/memberships/themes',
      _topics: 'entities/topics/findForTeam'
    }),
    ...mapGetters({
      _isLoading: 'entities/context/isLoading',
      _isUpdating: 'entities/users/isUpdating',
      _isDeleting: 'entities/memberships/isDeleting'
    }),
    isSelected(value) {
      return this.member.membership.topics.includes(value.id) ? 'checked' : '';
    },
    select(value) {
      if (this.memberThemes.includes(value.id)) {
        this.memberThemes = this.memberThemes.filter(current => {
          return current !== value.id;
        });
      } else {
        this.memberThemes.push(value.id);
      }
    },
    save() {
      if (this.isValidPassword) {
        this.member.user.password = this.update.password.trim();
      }

      this.updateTheUser();
    },
    saveThemes() {
      const data = {
        values: arraysData(this.memberThemes, this.originalThemes),
        member: this.member.membership
      };

      this._memberThemes(data).then(() => {
        this._newToast({
          text: 'Themes subscriptions updated',
          variant: 'good',
          duration: 2000
        });
      });
    },
    selectAvatar(avatar) {
      this.selectedAvatar = avatar;
      this.shouldUpload = false;
    },
    setAvatar() {
      this.member.user.avatarUrl = this.selectedAvatar;
      this.resetModal();
    },
    updateTheUser() {
      this._userUpdate(this.member.user).then(() => {
        this.update.password = '';
        this.update.confirm = '';

        this._newToast({
          text: 'User has been updated',
          variant: 'good',
          duration: 2000
        });
      });
    },
    signout() {
      this.$router.push({ path: '/logout' });
    },
    getActive(toCheck) {
      return this.selectedAvatar === toCheck ? 'choice active' : 'choice';
    },
    resetModal() {
      this.hasUpload = false;
      this.selectedAvatar = '';
      this.modal.avatar = false;
      this.selectedTab = { name: 'Own picture', slug: 'own_picture' };
    },
    setUpload(value) {
      Uploader(value.target.files[0]).then(result => {
        this.selectedAvatar = result.url;
        this.hasUpload = true;
      });
    },
    destroy() {
      const member = Context.query()
        .where(context => {
          return context.id === 'current';
        })
        .first().membership;

      this._memberRemove([member]).then(() => {
        this.modal.destroy = false;

        this._newToast({
          text: 'You have been removed, you will now be logged out',
          variant: 'good',
          duration: 2000
        });

        setTimeout(() => {
          this.$router.push({ path: '/logout' });
        }, 1000);
      });
    }
  }
};
